import * as React from 'react';
import { BUTTON_PRIMARY, BUTTON_SECONDARY, BUTTON_THIRDARY, BUTTON_DESTRUCTIVE, ButtonLadingContainer, BUTTON_LISMA } from './styles';
import { TC_BUTTON_TYPE } from './constants';
import InnerLoader from '../InnerLoader';

export interface TCButtonStateProps {
    type: string

    loading?: boolean
    disabled?: boolean
    state?: string
}

export interface TCButtonActionProps {
    onClick: (e) => void
}

export interface TCButtonSytleProps {
    backgroudColor?: string 
}

export interface TCButtonLoadingSytleProps {
    loaderButtonBackgroudColor?: string 
    loaderColor?: string 
    loaderButtonBorderColor?: string
    loaderButtonWidth?: number
}

declare type TCButtonProps = React.PropsWithChildren<TCButtonStateProps & TCButtonActionProps & TCButtonSytleProps & TCButtonLoadingSytleProps>

export const TCButton = (props: TCButtonProps) => {
    const buttonRef = React.useRef<HTMLElement | undefined>();

    const buttonWidth = React.useMemo(() => {
        if (buttonRef.current) {
            return buttonRef.current.clientWidth;
        }
        return undefined
    }, [buttonRef.current]);


    function getButtonForType(type: string) {
        switch (type) {
            case TC_BUTTON_TYPE.PRIMARY:
                return BUTTON_PRIMARY
            case TC_BUTTON_TYPE.SECONDARY:
                return BUTTON_SECONDARY
            case TC_BUTTON_TYPE.THIRDARY:
                return BUTTON_THIRDARY
            case TC_BUTTON_TYPE.DESTRUCTIVE:
                return BUTTON_DESTRUCTIVE
            case TC_BUTTON_TYPE.LISMA:
                return BUTTON_LISMA            
            default:
                throw new Error(`Type: ${type} is not valid for TCButton`);
        }
    }

    function renderLoadingButton() {
        return (
            <ButtonLadingContainer
                width={props.loaderButtonWidth??buttonWidth} background={props.loaderButtonBackgroudColor} borderColor={props.loaderButtonBorderColor}
            >
                <InnerLoader backgroundColor={props.loaderColor ?? "#FFF"} />
            </ButtonLadingContainer>
        )
    }

    if (props.loading) {
        return renderLoadingButton()
    } else {
        const ButtonContainer = getButtonForType(props.type)
        return (
            <ButtonContainer
                disabled={props.disabled}
                onClick={props.onClick}                    
                ref={buttonRef as any}
                backgroudColor= {props.backgroudColor}
            >
                {
                    props.children
                }
            </ButtonContainer>
        )
    }
    throw null;

}